import { DASHBOARD_OPTIONS, optionDefaultForRol } from '@cumlaude/shared-dashboard-registry';
import { CumLaudeRoute } from '@cumlaude/shared-components-menu';
import { isEqual } from 'lodash-es';
import { UserRouteData } from './user-routes.service';
import { OPTION_ENUMS } from './weergave-opties';

/** De queryparam staat op 3.1 (drie schooljaren zonder coronajaar), wat buiten dat jaar hetzelfde is als 3. */
const EFFECTIVE_DEFAULTS: Record<string, string> = { 'indicator-over': '3' };

type ConfigDefaults = Record<string, { def: unknown; encode: (val: any) => string | string[] }>;

/**
 * `DASHBOARD_OPTIONS` gaat naar de AI-chat. Deze controle (alleen dev-mode) meldt als het afwijkt van de
 * queryparams die de applicatie echt kent, of als geen enkel dashboard een optie ondersteunt.
 */
export function controleerQueryParamsUitRegistry(configs: ConfigDefaults, routes: CumLaudeRoute<UserRouteData>[]) {
	const weergaveOpties = new Set(verzamelWeergaveOpties(routes));

	const problemen = DASHBOARD_OPTIONS.flatMap((option: (typeof DASHBOARD_OPTIONS)[number]) => {
		const config = configs[option.param];
		if (!config) return [`${option.param} staat niet in de queryparams`];

		const gevonden: string[] = [];
		if (!('global' in option) && !weergaveOpties.has(option.param))
			gevonden.push(`${option.param} staat bij geen enkel dashboard in de weergave-opties`);

		const standaard = optionDefaultForRol(option, undefined);
		const paramDefault = EFFECTIVE_DEFAULTS[option.param] ?? config.encode(config.def);
		if (standaard !== undefined && !isEqual(paramDefault, standaard))
			gevonden.push(`${option.param} heeft in de registry default ${standaard}, maar de queryparam ${String(paramDefault)}`);

		if ('values' in option) {
			const uitRegistry = option.values.map((v) => v.value);
			const werkelijk = OPTION_ENUMS[option.param] ? Object.values(OPTION_ENUMS[option.param]) : undefined;
			if (!werkelijk) gevonden.push(`${option.param} staat niet in OPTION_ENUMS`);
			else if (!isEqual([...uitRegistry].sort(), [...werkelijk].sort()))
				gevonden.push(
					`${option.param} heeft in de registry andere waarden (${uitRegistry.join(', ')}) dan de enum (${werkelijk.join(', ')})`
				);
		}
		return gevonden;
	});
	if (problemen.length === 0) return;

	console.error(
		`DASHBOARD_OPTIONS en de queryparams verschillen: ${problemen.join('; ')}. Werk de registry bij, anders krijgt de AI-chat verouderde informatie.`
	);
}

function verzamelWeergaveOpties(routes: CumLaudeRoute<UserRouteData>[]): string[] {
	return routes.flatMap((route) => [
		...(route.data?.fixedWeergaveOpties ?? []),
		...(route.data?.flexibleWeergaveOpties ?? []),
		...verzamelWeergaveOpties(route.children ?? []),
	]);
}
